import { useContext, useEffect } from "react";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ChaptersModal from "./components/Modals/ChaptersModal";
import ContinueModal from "./components/Modals/ContinueModal";
import QuestionsModal from "./components/Modals/QuestionsModal";
import VideoPlayer from "./components/VideoPlayer";

import { data } from "./data";
import { Context } from "./store";

import resources from "./assets/translations/index";
import LanguageSelect from "./components/Modals/LanguageSelect";
import { LANGUAGES } from "./components/VideoPlayer";
import { useTranslation } from "react-i18next";

i18n.use(initReactI18next).use(LanguageDetector).init({
  resources,
  fallbackLng: "en",
});

function App() {
  const { i18n } = useTranslation();
  const [
    {
      player,
      index,
      continueShowing,
      questionsShowing,
      chaptersShowing,
      languagesShowing,
    },
  ] = useContext(Context);

  useEffect(() => {
    const lang = new URLSearchParams(
      window.location.search
    ).get("q");

    if (lang && i18n && resources.hasOwnProperty(lang)) {
      i18n.changeLanguage(lang);
    }
  }, [i18n]);

  useEffect(() => {
    if (i18n?.language && player) {
      const parsedLang = i18n?.language?.includes("-")
        ? i18n?.language.split("-")[0]
        : i18n?.language;

      console.log(`Setting captions to: ${parsedLang}`);
      if (LANGUAGES.hasOwnProperty(parsedLang))
        player.language = parsedLang;
    }
  }, [i18n?.language, player]);

  return (
    <>
      {index < data.length ? (
        <VideoPlayer />
      ) : (
        <div>Congratulations on completing the course</div>
      )}

      <ContinueModal showing={continueShowing} />
      <QuestionsModal showing={questionsShowing} />
      <ChaptersModal showing={chaptersShowing} />
      <LanguageSelect showing={languagesShowing} />
    </>
  );
}

export default App;
